import { gql } from '@lcs/shared/api';

export const getProviderCallRateDetail = gql`
   query GetProviderCallRateDetail($id: Int!) {
      providerCallRate(id: $id) {
         providerCallRateId
         providerId
         zone
         area
         rate
         destination
         code
      }
   }
`;
